import axios from "axios";
const offset = new Date().getTimezoneOffset();
axios.defaults.baseURL = process.env.REACT_API_BASE_URL;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
    config.validateStatus = status => status === 500 || status === 200;
    if (config.headers)
        config.headers["X-TimezoneOffset"] = -offset;
    return config;
}, error => Promise.reject(error));
